export enum AppStateErrorType {
  GENERAL_ERROR = 'error',
  CREDENTIALS = 'credentials',
}

export enum ErrorStatus {
  /**
   * AUTHENTICATION_ERROR means that the end user did not successfully authenticate towards the financial institution
   */
  AUTHENTICATION_ERROR = 'AUTHENTICATION_ERROR',

  /**
   * BAD_REQUEST means that the Tink Link URL was incorrectly configured
   */
  BAD_REQUEST = 'BAD_REQUEST',

  /**
   * TEMPORARY_ERROR are all errors that do not provide direct actionable
   * feedback to the third party (it could be related to Tink's services, authentication flow,
   * Javascript errors, etc.)
   */
  TEMPORARY_ERROR = 'TEMPORARY_ERROR',

  /**
   * USER_CANCELLED means that the end user cancelled the flow
   */
  USER_CANCELLED = 'USER_CANCELLED',
  /**
   * USER_CANCELLED_WITH_ALTERNATE_FLOW means that the end user cancelled by a feature toggled flow
   */
  USER_CANCELLED_WITH_ALTERNATE_FLOW = 'USER_CANCELLED_WITH_ALTERNATE_FLOW',

  /**
   * INTERNAL_ERROR means that something in the Tink APIs did not act as expected
   */
  INTERNAL_ERROR = 'INTERNAL_ERROR',
}

export enum ErrorReason {
  UNEXPECTED_ERROR = 'UNEXPECTED_ERROR',
  USER_CANCELLED = 'USER_CANCELLED',

  INVALID_PARAMETER_INPUT_USERNAME = 'INVALID_PARAMETER_INPUT_USERNAME',
  INVALID_PARAMETER_SCOPE = 'INVALID_PARAMETER_SCOPE',
  INVALID_PARAMETER_CLIENT_ID = 'INVALID_PARAMETER_CLIENT_ID',
  INVALID_PARAMETER_REDIRECT_URI = 'INVALID_PARAMETER_REDIRECT_URI',
  INVALID_PARAMETER_PAYMENT_REQUEST_ID = 'INVALID_PARAMETER_PAYMENT_REQUEST_ID',
  INVALID_PARAMETER_INPUT_PROVIDER = 'INVALID_PARAMETER_INPUT_PROVIDER',
  INVALID_PARAMETER_AUTHORIZATION_CODE = 'INVALID_PARAMETER_AUTHORIZATION_CODE',
  INVALID_PARAMETER_REFRESHABLE_ITEMS = 'INVALID_PARAMETER_REFRESHABLE_ITEMS',
  INVALID_PARAMETER_CONSENT_ID = 'INVALID_PARAMETER_CONSENT_ID',
  INVALID_PARAMETER_PRODUCTS = 'INVALID_PARAMETER_PRODUCTS',
  INVALID_PARAMETER_CREDENTIALS_ID = 'INVALID_PARAMETER_CREDENTIALS_ID',
  INVALID_PARAMETER_FINANCIAL_SERVICES_SEGMENTS = 'INVALID_PARAMETER_FINANCIAL_SERVICES_SEGMENTS',
  INVALID_PARAMETER_REPORT_TYPES = 'INVALID_PARAMETER_REPORT_TYPES',
  INVALID_PARAMETER_ACCOUNT_DIALOG_TYPE = 'INVALID_PARAMETER_ACCOUNT_DIALOG_TYPE',
  INVALID_PARAMETER_IDENTIFIER_TYPE = 'INVALID_PARAMETER_IDENTIFIER_TYPE',
  INVALID_PARAMETER_EXTERNAL_REFERENCE = 'INVALID_PARAMETER_EXTERNAL_REFERENCE',
  INVALID_PARAMETER_HANDOFF_URL = 'INVALID_PARAMETER_HANDOFF_URL',
  INVALID_PARAMETER = 'INVALID_PARAMETER',

  REQUEST_FAILED_CREATE_CREDENTIALS = 'REQUEST_FAILED_CREATE_CREDENTIALS',
  REQUEST_FAILED_OAUTH_DESCRIBE = 'REQUEST_FAILED_OAUTH_DESCRIBE',
  REQUEST_FAILED_FETCH_PROVIDERS = 'REQUEST_FAILED_FETCH_PROVIDERS',
  REQUEST_FAILED_FETCH_PAYMENT_INFO = 'REQUEST_FAILED_FETCH_PAYMENT_INFO',
  REQUEST_FAILED_CREATE_ANONYMOUS_USER = 'REQUEST_FAILED_CREATE_ANONYMOUS_USER',
  REQUEST_FAILED_REFRESH_CREDENTIALS = 'REQUEST_FAILED_REFRESH_CREDENTIALS',
  REQUEST_FAILED_FETCH_EXISTING_USER = 'REQUEST_FAILED_FETCH_EXISTING_USER',
  REQUEST_FAILED_FETCH_USER_WITH_EXISTING_TOKEN = 'REQUEST_FAILED_FETCH_USER_WITH_EXISTING_TOKEN',
  REQUEST_FAILED_CREATE_TRANSFER = 'REQUEST_FAILED_CREATE_TRANSFER',
  REQUEST_FAILED_FETCH_ACCOUNTS = 'REQUEST_FAILED_FETCH_ACCOUNTS',
  REQUEST_FAILED_FETCH_SESSION = 'REQUEST_FAILED_FETCH_SESSION',
  REQUEST_FAILED_FETCH_LEGAL_TEXT = 'REQUEST_FAILED_FETCH_LEGAL_TEXT',
  REQUEST_FAILED_CREATE_ACCOUNT_CHECK_REPORT = 'REQUEST_FAILED_CREATE_ACCOUNT_CHECK_REPORT',
  REQUEST_FAILED_CREATE_INCOME_CHECK_REPORT = 'REQUEST_FAILED_CREATE_INCOME_CHECK_REPORT',
  REQUEST_FAILED_CREATE_EXPENSE_CHECK_REPORT = 'REQUEST_FAILED_CREATE_EXPENSE_CHECK_REPORT',
  REQUEST_FAILED_FETCH_CREDENTIALS = 'REQUEST_FAILED_FETCH_CREDENTIALS',
  REQUEST_FAILED_FETCH_PROVIDER_PAYMENT_CONDITIONS = 'REQUEST_FAILED_FETCH_PROVIDER_PAYMENT_CONDITIONS',
  REQUEST_FAILED_CREATE_RISK_INSIGHTS_REPORT = 'REQUEST_FAILED_CREATE_RISK_INSIGHTS_REPORT',
  REQUEST_FAILED_FETCH_HANDOFF_SESSION = 'REQUEST_FAILED_FETCH_HANDOFF_SESSION',
  REQUEST_FAILED_CONSUME_HANDOFF_SESSION = 'REQUEST_FAILED_CONSUME_HANDOFF_SESSION',
  REQUEST_FAILED_FETCH_BULK_PAYMENT = 'REQUEST_FAILED_FETCH_BULK_PAYMENT',
  REQUEST_FAILED_FETCH_BULK_PAYMENT_STATUS = 'REQUEST_FAILED_FETCH_BULK_PAYMENT_STATUS',
  REQUEST_FAILED_CREATE_BULK_PAYMENT = 'REQUEST_FAILED_CREATE_BULK_PAYMENT',
  REQUEST_FAILED_CREATE_REPORT = 'REQUEST_FAILED_CREATE_REPORT',
  REQUEST_FAILED_FETCH_REPORTS_DESCRIBE = 'REQUEST_FAILED_FETCH_REPORTS_DESCRIBE',
  REQUEST_FAILED_FETCH_TRANSFER_ACCOUNTS = 'REQUEST_FAILED_FETCH_TRANSFER_ACCOUNTS',
  REQUEST_FAILED_CREATE_RESET_CREDENTIALS = 'REQUEST_FAILED_CREATE_RESET_CREDENTIALS',
  REQUEST_FAILED_FETCH_PAYMENT_TRANSFER_INFO = 'REQUEST_FAILED_FETCH_PAYMENT_TRANSFER_INFO',
  REQUEST_FAILED_AUTHORIZE_CONSENT = 'REQUEST_FAILED_AUTHORIZE_CONSENT',
  REQUEST_FAILED_GET_CONSENT = 'REQUEST_FAILED_GET_CONSENT',
  REQUEST_FAILED_GET_CONSENT_AUTHORIZATION = 'REQUEST_FAILED_GET_CONSENT_AUTHORIZATION',
  REQUEST_FAILED_EXTEND_CONSENT = 'REQUEST_FAILED_EXTEND_CONSENT',
  REQUEST_FAILED_FETCH_PRE_INITIATION_CHECK = 'REQUEST_FAILED_FETCH_PRE_INITIATION_CHECK',
  REQUEST_FAILED_CREATE_HANDOFF_SESSION = 'REQUEST_FAILED_CREATE_HANDOFF_SESSION',
  REQUEST_FAILED_UPDATE_HANDOFF_SESSION = 'REQUEST_FAILED_UPDATE_HANDOFF_SESSION',
  REQUEST_FAILED_FETCH_BULK_PAYMENT_TRANSFERS = 'REQUEST_FAILED_FETCH_BULK_PAYMENT_TRANSFERS',
  REQUEST_FAILED_FETCH_PROVIDER = 'REQUEST_FAILED_FETCH_PROVIDER',
  REQUEST_FAILED_CREATE_AUTHORIZATION_CODE = 'REQUEST_FAILED_CREATE_AUTHORIZATION_CODE',
  REQUEST_FAILED_FETCH_PREINITIATION_CHECK = 'REQUEST_FAILED_FETCH_PREINITIATION_CHECK',
  REQUEST_FAILED_FETCH_TRANSFER_STATUS = 'REQUEST_FAILED_FETCH_TRANSFER_STATUS',
  REQUEST_FAILED_FETCH_TRANSFER_DETAILS = 'REQUEST_FAILED_FETCH_TRANSFER_DETAILS',
  REQUEST_FAILED_INITIATE_DIRECT_PAYMENT = 'REQUEST_FAILED_INITIATE_DIRECT_PAYMENT',
  REQUEST_FAILED_FETCH_CONFIGURATION = 'REQUEST_FAILED_FETCH_CONFIGURATION',
  REQUEST_FAILED_SUPPLEMENT_CREDENTIALS = 'REQUEST_FAILED_SUPPLEMENT_CREDENTIALS',
  REQUEST_FAILED_FETCH_THEMES = 'REQUEST_FAILED_FETCH_THEMES',
  REQUEST_FAILED_FETCH_MERCHANT_THEMES = 'REQUEST_FAILED_FETCH_MERCHANT_THEMES',
  REQUEST_FAILED_FETCH_MERCHANT_INFORMATION = 'REQUEST_FAILED_FETCH_MERCHANT_INFORMATION',
  REQUEST_FAILED_FETCH_PAYMENT = 'REQUEST_FAILED_FETCH_PAYMENT',
  REQUEST_FAILED_FETCH_DEMOBANK_SCENARIOS = 'REQUEST_FAILED_FETCH_DEMOBANK_SCENARIOS',
  REQUEST_FAILED_FETCH_REGION_MAPPINGS = 'REQUEST_FAILED_FETCH_REGION_MAPPINGS',

  REQUEST_TIMEOUT_GET_CONSENT_AUTHORIZATION = 'REQUEST_TIMEOUT_GET_CONSENT_AUTHORIZATION',
  REQUEST_TIMEOUT_GET_CONSENT = 'REQUEST_TIMEOUT_GET_CONSENT',

  REQUEST_TIMEOUT_GET_CREDENTIALS = 'REQUEST_TIMEOUT_GET_CREDENTIALS',

  BANK_AUTHORIZATION_FAILED = 'BANK_AUTHORIZATION_FAILED',
  BANK_AUTHORIZATION_CANCELLED = 'BANK_AUTHORIZATION_CANCELLED',

  INVALID_STATE_EMBED_NOT_ALLOWED = 'INVALID_STATE_EMBED_NOT_ALLOWED',
  INVALID_STATE_CREDENTIALS_IS_AWAITING_THIRD_PARTY = 'INVALID_STATE_CREDENTIALS_IS_AWAITING_THIRD_PARTY',
  INVALID_STATE_PROVIDER_DOES_NOT_RECOGNIZE_USER = 'INVALID_STATE_PROVIDER_DOES_NOT_RECOGNIZE_USER',
  INVALID_STATE_REDIRECTED_CREDENTIALS_ID = 'INVALID_STATE_REDIRECTED_CREDENTIALS_ID',
  INVALID_STATE_REDIRECTED_AUTHORIZATION_TOKEN = 'INVALID_STATE_REDIRECTED_AUTHORIZATION_TOKEN',
  INVALID_STATE_PERMANENT_USER_FLAG = 'INVALID_STATE_PERMANENT_USER_FLAG',
  INVALID_STATE_PAYMENT_RETRY_NOT_ALLOWED = 'INVALID_STATE_PAYMENT_RETRY_NOT_ALLOWED',
  INVALID_STATE_ACCESS_TOKEN = 'INVALID_STATE_ACCESS_TOKEN',
  INVALID_STATE_PROVIDER = 'INVALID_STATE_PROVIDER',
  INVALID_STATE_CREDENTIALS = 'INVALID_STATE_CREDENTIALS',
  INVALID_STATE_CONSENT = 'INVALID_STATE_CONSENT',
  INVALID_STATE_AUTHENTICATION = 'INVALID_STATE_AUTHENTICATION',
  INVALID_STATE_NON_OPEN_BANKING_PROVIDER = 'INVALID_STATE_NON_OPEN_BANKING_PROVIDER',
  /* A specified scope is not available for the client */
  INVALID_STATE_SCOPE = 'INVALID_STATE_SCOPE',
  /* The redirect_uri does not match any registered redirect_uris on the client */
  INVALID_STATE_REDIRECT_URI = 'INVALID_STATE_REDIRECT_URI',
  REQUEST_FAILED_FETCH_PROVIDER_CONSENT = 'REQUEST_FAILED_FETCH_PROVIDER_CONSENT',
  UNEXPECTED_HANDOFF_ERROR = 'UNEXPECTED_HANDOFF_ERROR',
  /* Error for accessing the bulk payment route but bulk not being enabled via feature flag */
  FEATURE_NOT_ENABLED_BULK_PAYMENTS = 'FEATURE_NOT_ENABLED_BULK_PAYMENTS',
  FEATURE_NOT_ENABLED_PIS_ONLY_BULK_PAYMENTS = 'FEATURE_NOT_ENABLED_PIS_ONLY_BULK_PAYMENTS',
  CONSENT_SCREEN_NOT_SUPPORTED = 'CONSENT_SCREEN_NOT_SUPPORTED',
  CLIENT_LEGAL_DOCS_NOT_CONFIGURED = 'CLIENT_LEGAL_DOCS_NOT_CONFIGURED',
  POLLING_TIMEOUT = 'POLLING_TIMEOUT',
  INVALID_STATE_TRANSFER = 'INVALID_STATE_TRANSFER',

  /* Payment was rejected by Tink since it failed fraud prevention */
  FAILED_FRAUD_PREVENTION_CHECK = 'FAILED_FRAUD_PREVENTION_CHECK',
  REQUEST_TIMEOUT_AUTHORISING_CREDENTIALS = 'REQUEST_TIMEOUT_AUTHORISING_CREDENTIALS',
  INVALID_STATE_SUPPLEMENTAL_INFO = 'INVALID_STATE_SUPPLEMENTAL_INFO',
  REQUEST_FAILED_AUTHENTICATE_CREDENTIALS_FAILED = 'REQUEST_FAILED_AUTHENTICATE_CREDENTIALS_FAILED',
  REQUEST_FAILED_GET_CREDENTIALS_ACCOUNTS_FAILED = 'REQUEST_FAILED_GET_CREDENTIALS_ACCOUNTS_FAILED',
  REQUEST_FAILED_POST_SELECTED_ACCOUNT_FAILED = 'REQUEST_FAILED_POST_SELECTED_ACCOUNT_FAILED',
  REQUEST_FAILED_FETCH_CREDENTIALS_RESET_STATUS_FAILED = 'REQUEST_FAILED_FETCH_CREDENTIALS_RESET_STATUS_FAILED',
  REQUEST_FAILED_FETCH_QR_CREDENTIALS_FAILED = 'REQUEST_FAILED_FETCH_QR_CREDENTIALS_FAILED',
  REQUEST_FAILED_REFRESH_CREDENTIALS_FAILED = 'REQUEST_FAILED_REFRESH_CREDENTIALS_FAILED',
  REQUEST_FAILED_RESET_CREDENTIALS_STATUS_FAILED = 'REQUEST_FAILED_RESET_CREDENTIALS_STATUS_FAILED',
  REQUEST_FAILED_FETCH_SUPPLEMENTAL_INFO_FAILED = 'REQUEST_FAILED_FETCH_SUPPLEMENTAL_INFO_FAILED',
  REQUEST_FAILED_DELETE_CREDENTIALS_FAILED = 'REQUEST_FAILED_DELETE_CREDENTIALS_FAILED',
  REQUEST_REJECTED_DUE_TO_ONGOING_PAYMENT_FOR_DIFFERENT_PROVIDER = 'REQUEST_REJECTED_DUE_TO_ONGOING_PAYMENT_FOR_DIFFERENT_PROVIDER',
  REQUEST_REJECTED_DUE_TO_ONGOING_PAYMENT_FOR_DIFFERENT_CREDENTIALS_ID = 'REQUEST_REJECTED_DUE_TO_ONGOING_PAYMENT_FOR_DIFFERENT_CREDENTIALS_ID',

  /**
   * FAILED_BULK_PAYMENT or PARTIALLY_FAILED_BULK_PAYMENT means that something in the bulk payments went wrong and the Failure Screen or Partial Success was shown
   */
  FAILED_BULK_PAYMENT = 'FAILED_BULK_PAYMENT',
  PARTIALLY_FAILED_BULK_PAYMENT = 'PARTIALLY_FAILED_BULK_PAYMENT',

  /* KYC errors */
  REQUEST_FAILED_FETCH_KYC_DETAILS = 'REQUEST_FAILED_FETCH_KYC_DETAILS',
}
